import { Radio } from "lucide-react";

const SRC_DOC = `<!doctype html><html><head><meta name="viewport" content="width=device-width,initial-scale=1">
<style>html,body{margin:0;padding:0;background:transparent;color:#fff;font-family:sans-serif;}</style></head>
<body><div class="cc_player" data-username="enduroradio">Loading ...</div>
<script language="javascript" type="text/javascript" src="https://control.internet-radio.com:2199/system/player.js"></script>
</body></html>`;

// Rendered in an iframe so the player script initialises fresh on every mount (SPA navigation).
export const RadioPlayer = () => (
  <section data-testid="enduroradio-section" className="py-10">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="rounded-2xl border border-amber-500/30 bg-[#14161A] p-5 sm:p-6">
        <h2 className="flex items-center gap-2 font-display text-2xl sm:text-3xl font-black uppercase text-white">
          <Radio className="w-6 h-6 text-amber-500" /> Lyssna på Enduroradio live
        </h2>
        <div className="mt-4">
          <iframe
            title="Enduroradio webbradio"
            data-testid="enduroradio-player"
            srcDoc={SRC_DOC}
            allow="autoplay"
            className="block w-[170px] h-[110px] border-0"
          />
        </div>
      </div>
    </div>
  </section>
);
